import { render, staticRenderFns } from "./CoventryEvent.vue?vue&type=template&id=be3dceb0&"
import script from "./CoventryEvent.vue?vue&type=script&lang=js&"
export * from "./CoventryEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports